import { render } from "./preset-form.vue?vue&type=template&id=0231098f&scoped=true"
import script from "./preset-form.vue?vue&type=script&lang=js"
export * from "./preset-form.vue?vue&type=script&lang=js"

import "./preset-form.vue?vue&type=style&index=0&id=0231098f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0231098f"]])

export default __exports__